module.exports = __webpack_public_path__ + "static/media/logo-sanpaolo-cinza-pg-sanpaolo.60fd9642.png";